export const DEALERSHIP = {
  name: "Findlay Chrysler Dodge Jeep Ram",
  location: "Findlay, OH",
  locationLong: "Findlay, Ohio",
  phone: "419-423-1715",
  salesPhone: "419-423-1715",
  servicePhone: "419-423-1715",
  partsPhone: "419-423-1715",
  address: "10305 U.S. 224 West, Findlay, OH 45840",
  streetAddress: "10305 U.S. 224 West",
  city: "Findlay",
  state: "OH",
  postalCode: "45840",
  country: "US",
  latitude: 41.058745,
  longitude: -83.682039,
  dealerPermit: "ND003805",
  website: "https://www.findlaychrysler.com/",
  newVehicles: "https://www.findlaychrysler.com/new-vehicles/",
  usedVehicles: "https://www.findlaychrysler.com/used-vehicles/",
  service: "https://www.findlaychrysler.com/service/",
  scheduleService: "https://www.findlaychrysler.com/service/schedule-service/",
  parts: "https://www.findlaychrysler.com/order-parts/",
  finance: "https://www.findlaychrysler.com/finance/",
  tradeIn: "https://www.findlaychrysler.com/whats-your-car-worth/",
  contact: "https://www.findlaychrysler.com/contact-us/",
  about: "https://www.findlaychrysler.com/about-us/",
  driveFindlay: "https://www.findlaychrysler.com/drive-findlay/",
  bbbReviews:
    "https://www.bbb.org/us/oh/findlay/profile/new-car-dealers/findlay-chrysler-dodge-jeep-ram-0422-22000044/customer-reviews",
  yelp: "https://www.yelp.com/biz/findlay-chrysler-dodge-jeep-ram-findlay",
  makes: ["Chrysler", "Dodge", "Jeep", "Ram"],
  nearbyMarkets: ["Findlay", "Tiffin", "Fremont", "Bowling Green", "Toledo", "Columbus"],
};
